import type React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

interface Step {
  label: string;
  prompt: string;
}

interface StepCalloutProps {
  steps: Step[];
  sx?: SxProps<Theme>;
}

const StepCallout = ({ steps, sx }: StepCalloutProps): React.JSX.Element => {
  if (!steps.length) return <></>;

  return (
    <Stack sx={sx}>
      {steps.map((step, index) => {
        const isLast = index === steps.length - 1;

        return (
          <Stack key={index}>
            <Stack direction="row" sx={{ alignItems: 'center', gap: 1.5 }}>
              <Stack
                direction="row"
                sx={{
                  width: '1.5rem',
                  height: '1.5rem',
                  flexShrink: 0,
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '9999px',
                  bgcolor: 'tokens.gray.100',
                  fontSize: '0.75rem',
                  lineHeight: '1rem',
                  fontWeight: 600,
                  color: 'tokens.gray.900',
                }}
              >
                {index + 1}
              </Stack>
              <Box
                sx={{
                  flex: '1 1 0%',
                  borderRadius: '0.375rem',
                  bgcolor: 'tokens.gray.100',
                  px: 1.5,
                  py: 1,
                }}
              >
                <h3 className="text-xs font-medium leading-4 text-gray-500">
                  {step.label}
                </h3>
                <p className="text-base text-gray-900">{step.prompt}</p>
              </Box>
            </Stack>

            {!isLast && (
              <Box
                sx={{
                  ml: '11px',
                  height: '1rem',
                  width: '1px',
                  bgcolor: 'tokens.gray.300',
                }}
                aria-hidden="true"
              />
            )}
          </Stack>
        );
      })}
    </Stack>
  );
};

export default StepCallout;
